import {
  AfterViewInit,
  Component,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  APIRequestBodyModel,
  ClientProductRatePlanModel,
  ContainerItemModel,
  ContainerItemOption,
  ContainerModel,
  LayoutModel,
} from '@app/models/server/layout.model';
import {
  AsyncPipe,
  DOCUMENT,
  NgClass,
  NgOptimizedImage,
  NgTemplateOutlet,
} from '@angular/common';
import { Store } from '@ngrx/store';
import * as fromRoot from '@app/store';
import { FormsModule } from '@angular/forms';
import { EventService } from '@app/services/util-services/root-services/event-service';
import { OverlayEventDetail } from '@ionic/core';
import { HttpClientService } from '@app/services/util-services/root-services/http-client.service';
import { HttpErrorResponse } from '@angular/common/http';
import { B2bDragScrollComponent } from '@app/new-ui-lib/b2b-drag-scroll/b2b-drag-scroll/b2b-drag-scroll.component';
import { B2bDragScrollItemComponent } from '@app/new-ui-lib/b2b-drag-scroll/b2b-drag-scroll-item/b2b-drag-scroll-item.component';
import { DragScrollType } from '@app/models/client/drag-scroll.type';
import { AvailableHoursPipe } from '@app/components/pipes/available-hours/available-hours.pipe';
import { AnalyticsEventService } from '@app/services/util-services/root-services/analytics-event-service';
import { B2bDeviceUtilService } from '@app/services/util-services/root-services/b2b-device-util.service';
import { SafePipe } from '@app/components/pipes/safe/safe.pipe';
import { Subscription } from 'rxjs';
import { FEATURE_TYPES } from '@app/constants/app-settings';
import {
  IonContent,
  IonModal,
  ModalController,
} from '@ionic/angular/standalone';
import { B2bPopoverV1Component } from '@app/new-ui-lib/b2b-popover-v1/b2b-popover-v1.component';
import { environment } from '@src/environments/environment';
import {TapEffect} from '@app/components/directives/tap-effect.ts/tap-effect';

@Component({
  selector: 'b2b-detail-page-cart',
  templateUrl: './detail-page-cart.component.html',
  styleUrls: ['./detail-page-cart.component.scss'],
  standalone: true,
  imports: [
    AsyncPipe,
    FormsModule,
    NgOptimizedImage,
    NgClass,
    NgTemplateOutlet,
    B2bDragScrollComponent,
    B2bDragScrollItemComponent,
    AvailableHoursPipe,
    SafePipe,
    IonModal,
    IonContent,
    B2bPopoverV1Component,
    TapEffect,
  ],
})
export class DetailPageCartComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() compData: {
    containers: ContainerModel[];
    layoutData: LayoutModel;
  };

  coupon: string;
  enableRedeemCreditPoints: boolean;
  referralCode: string;
  membershipBody: {
    isAdd: boolean;
    apiRequestBody: APIRequestBodyModel;
  };

  availableDatesContainer: ContainerModel[];
  swiperConfig: DragScrollType = {
    autoHeight: true,
    spaceBetween: 10,
    navigation: false,
    freeMode: false,
    mousewheel: false,
    grabCursor: false,
    pagination: false,
    slidesPerView: 3.8,
    centeredSlides: false,
    injectStyles: [],
    hideScrollButtons: false,
    showAbsoluteButtons: true,
  };

  selectedAvailableDate: ContainerItemOption;
  selectedAvailableCheckinTime: ContainerItemOption;
  selectedAvailableHour: ContainerItemOption;

  modifyError: {
    type: string;
    message: string;
  };

  nextAvailableDatesAreNotAvailable = false;
  isServer: boolean = this.b2bDeviceUtilService.isServer();
  url: string = this.b2bDeviceUtilService?.getMobileAppLink();

  couponContainer: ContainerModel;
  isMobile: boolean =
    environment?.mobileApp || !this.b2bDeviceUtilService.isDesktop();
  @ViewChild('couponModal') couponModal: IonModal;
  @ViewChild('bookingInfoModal') bookingInfoModal: IonModal;

  toggleFoodActionEventSubscription: Subscription;
  toggleRoomActionEventSubscription: Subscription;

  protected readonly environment = environment;

  constructor(
    private rootStore: Store<fromRoot.State>,
    private eventService: EventService,
    private modalController: ModalController,
    private httpClientService: HttpClientService,
    @Inject(DOCUMENT) private readonly document: Document,
    public analyticsEventService: AnalyticsEventService,
    private b2bDeviceUtilService: B2bDeviceUtilService,
  ) {}

  ngAfterViewInit(): void {
    if (this.compData?.containers?.length === 1) {
      if (
        this.compData?.containers[0]?.errorHandler?.pleaseSelectRoomCard?.title
      ) {
        this.gotoRooms();
      }
    }
  }

  ngOnInit() {
    this.handleNextAvailableDates();
    this.toggleFoodActionEventSubscription =
      this.eventService.toggleFoodActionEvent.subscribe({
        next: (result: {
          foodItem?: {
            selectedContainer: ContainerItemModel;
            isAdded: boolean;
          };
        }) => {
          // TODO handle food event
          this.callActionApi(false, result?.foodItem, null);
        },
      });

    this.toggleRoomActionEventSubscription =
      this.eventService.toggleRoomActionEvent.subscribe({
        next: (roomItem: {
          selectedRatePlans?: ClientProductRatePlanModel[];
          operationType?: string;
        }) => {
          // TODO handle food event
          this.callActionApi(false, null, roomItem);
        },
      });
  }

  applyReferralCode() {
    this.callActionApi(false, null, null);
  }

  applyCoupon(couponCard: ContainerModel) {
    if (couponCard?.isUserLoggedIn) {
      this.callActionApi(false, null, null);
    } else {
      this.openLoginPopup().then();
    }
  }

  toggleCreditPoint() {
    this.callActionApi(false, null, null);
  }

  toggleMembership(isAdd: boolean, membershipCard: ContainerModel) {
    this.membershipBody = {
      isAdd,
      apiRequestBody: membershipCard?.apiRequestBody,
    };
    this.callActionApi(false, null, null);
  }

  showCouponList(couponCard: ContainerModel) {
    if (couponCard?.isUserLoggedIn) {
      this.getCoupons(this.compData?.layoutData?.queryParams);
    } else {
      this.openLoginPopup().then();
    }
  }

  continueBooking(): void {
    if (this.compData?.containers?.length === 1) {
      if (
        this.compData?.containers[0] &&
        this.compData?.containers[0]?.newCartDescription?.featureTypes?.includes(
          FEATURE_TYPES.SHORTSTAY,
        )
      ) {
        this.openBookingInfoModal();
        return;
      }
    }
    this.callActionApi(true, undefined, null);
  }

  async openLoginPopup() {
    const module = await import('@b2b/auth-lib');

    const componentProps: {
      compData: {
        pageType: string;
        isModal: boolean;
        disablePageNavigation: boolean;
      };
    } = {
      compData: {
        pageType: 'login',
        isModal: true,
        disablePageNavigation: true,
      },
    };

    const modal: HTMLIonModalElement = await this.modalController.create({
      component: module.AuthModalComponent,
      componentProps,
      initialBreakpoint: 1,
      cssClass: 'auth-modal',
    });

    modal.onDidDismiss().then((result: OverlayEventDetail<{}>) => {
      // LoggerService.log('Login popup ', result.data);
      if (result && result?.data) {
      }
    });
    return await modal.present();
  }

  gotoSimilarProperties() {
    this.document
      .getElementById('similar_properties_container')
      ?.scrollIntoView({
        behavior: 'smooth',
      });
  }

  gotoRooms() {
    this.document?.getElementById('room_container')?.scrollIntoView({
      behavior: 'smooth',
    });
  }

  onNextAvailableDate(option: ContainerItemOption) {
    if (option?.availableRooms > 0) {
      this.selectedAvailableDate = option;
      if (this.modifyError?.type === 'AVAILABLE_DATE_ERROR') {
        this.modifyError = undefined;
      }
    }
  }

  onNextAvailableCheckInTime(option: ContainerItemOption) {
    this.selectedAvailableHour = undefined;
    if (
      this.compData?.containers[0]?.errorHandler?.nextAvailableDatesCard?.title
    ) {
      if (!this.selectedAvailableDate) {
        this.modifyError = {
          type: 'AVAILABLE_DATE_ERROR',
          message: 'Please select next available date',
        };
        return;
      } else {
        this.selectedAvailableCheckinTime = option;
      }
    } else {
      this.selectedAvailableCheckinTime = option;
    }
    if (this.modifyError?.type === 'AVAILABLE_CHECK_IN_TIME_ERROR') {
      this.modifyError = undefined;
    }
  }

  onNextAvailableHour(option: ContainerItemOption) {
    if (option?.disabled) {
      return;
    }
    if (
      this.compData?.containers[0]?.errorHandler?.nextAvailableCheckInTimeCard
        ?.title
    ) {
      if (!this.selectedAvailableCheckinTime) {
        this.modifyError = {
          type: 'AVAILABLE_CHECK_IN_TIME_ERROR',
          message: 'Please select available checkin time',
        };
        return;
      } else {
        this.selectedAvailableHour = option;
      }
    } else {
      this.selectedAvailableHour = option;
    }
    if (this.modifyError?.type === 'AVAILABLE_HOUR_ERROR') {
      this.modifyError = undefined;
    }
  }

  modifySearch() {
    this.modifyError = undefined;
    if (
      this.compData?.containers[0]?.errorHandler?.nextAvailableDatesCard?.title
    ) {
      if (!this.selectedAvailableDate) {
        this.modifyError = {
          type: 'AVAILABLE_DATE_ERROR',
          message: 'Please select available date',
        };
        return;
      }
    }
    if (
      this.compData?.containers[0]?.errorHandler?.nextAvailableCheckInTimeCard
        ?.title
    ) {
      if (!this.selectedAvailableCheckinTime) {
        this.modifyError = {
          type: 'AVAILABLE_CHECK_IN_TIME_ERROR',
          message: 'Please select available checkin time',
        };
        return;
      }
    }
    if (
      this.compData?.containers[0]?.errorHandler?.nextAvailableHourCard?.title
    ) {
      if (!this.selectedAvailableHour) {
        this.modifyError = {
          type: 'AVAILABLE_HOUR_ERROR',
          message: 'Please select available hour',
        };
        return;
      }
    }

    this.resetData(
      this.selectedAvailableDate,
      this.selectedAvailableCheckinTime,
      this.selectedAvailableHour,
    );
  }

  getCoupons(queryParams: any) {
    this.httpClientService
      .post('coupon-service/get-feature-coupons', { queryParams }, {})
      .pipe()
      .subscribe({
        next: (containers: ContainerModel[]) => {
          if (containers?.length === 1) {
            this.couponContainer = containers[0];
          }
          this.openCouponModal();
        },
        error: (errorResponse: HttpErrorResponse) => {},
      });
  }

  openCouponModal() {
    if (this.couponModal) {
      this.couponModal?.present().then();
    } else {
      if (!this.b2bDeviceUtilService?.isServer()) {
        setTimeout(() => {
          this.couponModal.present().then();
        }, 1000);
      }
    }
  }

  dismissCouponModal() {
    this.couponModal?.dismiss()?.then();
  }

  applyCouponInModal(container: ContainerModel) {
    this.coupon = container?.title;
    if (this.compData?.containers?.length > 0) {
      this.applyCoupon(this.compData?.containers[0]?.promotionData?.couponCard);
    }
    this.dismissCouponModal();
  }

  openBookingInfoModal() {
    if (this.bookingInfoModal) {
      this.bookingInfoModal?.present().then();
    } else {
      if (!this.b2bDeviceUtilService?.isServer()) {
        setTimeout(() => {
          this.bookingInfoModal.present().then();
        }, 1000);
      }
    }
  }

  dismissBookingInfoModal() {
    this.bookingInfoModal?.dismiss()?.then();
  }

  continueToBooking() {
    this.callActionApi(true, undefined, null);
  }

  modify() {
    this.document?.getElementById('search-form')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'end',
    });
  }

  ngOnDestroy(): void {
    this.destroy();
  }

  destroy() {
    if (this.toggleFoodActionEventSubscription) {
      this.toggleFoodActionEventSubscription.unsubscribe();
    }
    if (this.toggleRoomActionEventSubscription) {
      this.toggleRoomActionEventSubscription.unsubscribe();
    }
  }

  private handleNextAvailableDates() {
    if (
      this.compData?.containers?.length > 0 &&
      this.compData?.containers[0]?.errorHandler?.nextAvailableDatesCard?.title
    ) {
      const container: ContainerModel =
        this.compData?.layoutData?.nextAvailabilitiesContainer[0];
      this.httpClientService
        .post(
          container?.apiURL,
          {
            apiRequestBody: container?.apiRequestBody,
          },
          {},
        )
        .pipe()
        .subscribe({
          next: (res: ContainerModel[]) => {
            this.availableDatesContainer = res;
            if (this.availableDatesContainer?.length > 0) {
              if (
                !this.availableDatesContainer[0]?.options ||
                this.availableDatesContainer[0]?.options?.length === 0
              ) {
                this.nextAvailableDatesAreNotAvailable = true;
              }
            }
          },
          error: (errorResposne: HttpErrorResponse) => {
            console.error(
              'Inside handleNextAvailableDates() errorResposne ',
              errorResposne,
            );
          },
        });
    }
  }

  private resetData(
    nextAvailableDate: ContainerItemOption,
    nextAvailableCheckinTime: ContainerItemOption,
    nextAvailableHour: ContainerItemOption,
  ) {
    this.eventService.newActionApiEvent.emit({
      resetData: {
        nextAvailableDate,
        nextAvailableCheckinTime,
        nextAvailableHour,
      },
    });
    this.selectedAvailableDate = undefined;
    this.selectedAvailableCheckinTime = undefined;
    this.selectedAvailableHour = undefined;
  }

  private callActionApi(
    createCheckoutData: boolean,
    foodItem: {
      selectedContainer: ContainerItemModel;
      isAdded: boolean;
    },
    roomItem: {
      selectedRatePlans?: ClientProductRatePlanModel[];
      operationType?: string;
    },
  ) {
    this.eventService.newActionApiEvent.emit({
      rewardData: {
        coupon: this.coupon,
        enableRedeemCreditPoints: this.enableRedeemCreditPoints,
        membershipBody: this.membershipBody,
      },
      foodItem,
      createCheckoutData,
      selectedRatePlans: roomItem?.selectedRatePlans,
      operationType: roomItem?.operationType,
    });
  }
}
